import React from "react";

const Notfound = () => {
  return <h1>Not Found Page</h1>;
};

export default Notfound;
